import { patch, read } from '@/utils/request'
import type { BatchProcessingParams, BatchProcessingRes, DetailWithLogs, ListData } from 'bv-typings'
import { paramsArray2Str, toggleTime } from '@/utils'


export type IGameResearchInfo = {
  entity: string	// 开户主体
  companyType: string	// 公司类型 ：自研自发/代理发行
  companyStatus: string	// 公司现状：创业/大厂背景
  financing: string	// 融资情况
  domesticToOverseas: string	// 是否国内转海外
  yearsOfOverseasAdvertising: string	// 海外投放年数
  teamSize: string	// 团队规模（人）
  optimizationGroupSize: string	// 优化组（人）
  materialProductionTeamType: string	// 素材制作团队类型: 自制/外包
  ue4Support: string	// 素材制作团队是否支持UE4
  productAmount: string	// 产品数量
  productStage: string	// 产品阶段: 已推广/未上线/预注册中
  gameType: string	// 游戏类型: RPG Strategy Casual Puzzle Casino Real money gambling Simulation Arcade Action
  ipExist: string	// 是否有IP
  monetizationMode: string	// 变现模式: IAA/IAP/IAA+IAP
  country: string	// 国家
  subject: string	// 核算主体: 蓝瀚+MadHouse
  createdTime: string // 数据生成时间
  updatedTime: string // 最终编辑时间
}

type IGameResearchListParams = {
  entity: string
  gameType: number
  createStart: string
  createEnd: string
  updateStart: string
  updateEnd: string
}

export type INonGameResearchInfo = {
  settlement: string	// 结算主体
  customerType: string	// 客户类型: 直客/代理
  businessType: string[]	// 业务类型: app/ec/其他
  stationGroup: string	// 是否站群
  cooperateWithOtherAgents: string	// 是否也其他代理合作
  estimatedEntityNumberOfMonth: string	// 预估月开户主体个数
  estimatedAccountNumberOfMonth: string	// 预估月开户账户个数
  estimatedConsumptionOfMonth: string	// 预估月消耗量级
  // subject: string	// 核算主体: 蓝瀚+MadHouse
  createTime: string // 数据生成时间
  editTime: string // 最终编辑时间
}

type INonGameResearchListParams = {
  settlement: string
  customerType: string
  businessType: string
  stationGroup: string
  createStart: string
  createEnd: string
  updateStart: string
  updateEnd: string
}

const transferInfoResearchParams = (params: any) => toggleTime(toggleTime(
  params, 'create', 'createStart', 'createEnd',
), 'update', 'updateStart', 'updateEnd')

function getGameResearchList (params?: IGameResearchListParams) {
  return read<ListData<IGameResearchInfo>> ('customer_info_research/cir_games', transferInfoResearchParams(params))
}

async function getGameResearchDetail (id: string) {
  return read<DetailWithLogs<IGameResearchInfo>> ('customer_info_research/cir_games', undefined, '获取调研详情失败', id )
}

async function batchEditGameResearch (params: BatchProcessingParams<IGameResearchInfo>[]) {
  return patch<BatchProcessingRes> ('customer_info_research/cir_games', params)
}


async function editGameResearch (params: BatchProcessingParams<IGameResearchInfo>, id: string) {
  return patch<any> ('customer_info_research/cir_games', paramsArray2Str(params), '修改客户信息失败', id)
}

async function getNonGameResearchList (params?: INonGameResearchListParams) {
  return read<ListData<INonGameResearchInfo>> ('customer_info_research/cir_non_games', transferInfoResearchParams(params))
}

async function getNonGameResearchDetail (id: string) {
  return read<DetailWithLogs<INonGameResearchInfo>> ('customer_info_research/cir_non_games', undefined, '获取调研详情失败', id )
}

async function batchEditNonGameResearch (params: BatchProcessingParams<INonGameResearchInfo>[]) {
  return patch<BatchProcessingRes> ('customer_info_research/cir_non_games', params)
}

async function editNonGameResearch (params: BatchProcessingParams<INonGameResearchInfo>, id: string) {
  return patch<any> ('customer_info_research/cir_non_games', paramsArray2Str(params), '修改客户信息失败', id)
}


const listService = {
  game: getGameResearchList,
  nonGame: getNonGameResearchList,
}

const detailService = {
  game: getGameResearchDetail,
  nonGame: getNonGameResearchDetail,
}

const batchService = {
  game: batchEditGameResearch,
  nonGame: batchEditNonGameResearch,
}
const editService = {
  game: editGameResearch,
  nonGame: editNonGameResearch,
}

export {
  getGameResearchList,
  getGameResearchDetail,
  batchEditGameResearch,
  getNonGameResearchList,
  getNonGameResearchDetail,
  batchEditNonGameResearch,
  editGameResearch,
  editNonGameResearch,
  listService,
  detailService,
  batchService,
  editService,
}
